<div class="root container my-4">
  <div class="row">
    <div class="col-12 col-md-6 container">
      <div class="row align-items-center">
        <h2 i18n class="col-6 font-weight-bolder">Sign in</h2>
      </div>
      <iframe
        id="loginFrame"
        #loginframe
        [src]="(prefillEmail ? B2CSignin + '?prefill_email=' + prefillEmail : B2CSignin) | safeUrl"
        frameborder="0"
        scrolling="no"
      >
      </iframe>
    </div>
  </div>
</div>
